import { axiosInstance } from "./";

const subCategoriesList = async ({ params }) =>
  await axiosInstance.get("/api/SubCategory/GetAll", {
    params,
    paramsSerializer: { indexes: null }
  });

const addSubCategory = async (data) =>
  await axiosInstance.post("/api/SubCategory/Add", data);

const editSubCategory = async (data) =>
  await axiosInstance.put("/api/SubCategory/Edit", data);

const getSubCategoryDetails = async ({ id }) =>
  await axiosInstance.get(`/api/SubCategory/GetById/${id}`);

const deleteSubCategory = async ({ data }) =>
  await axiosInstance.put("/api/SubCategory/Delete", data);

const subCategoryProductsList = async ({ params }) =>
  await axiosInstance.get("/api/Product/GetProductsBySubCategoryId", {
    params,
    paramsSerializer: { indexes: null }
  });

export {
  subCategoriesList,
  addSubCategory,
  editSubCategory,
  getSubCategoryDetails,
  deleteSubCategory,
  subCategoryProductsList
};
